import { lazy } from "react"

export const Account = lazy(() => import("./account"))
